var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellowFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2301_4969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1815 1.89622C7.85695 0.576575 5.41388 0.45314 3.06445 1.50671V0.779297H2.00977V18.6624H3.06445V12.1402C5.22899 11.0122 7.50209 11.0474 9.65832 12.2714C10.9514 13.0056 12.2811 13.3724 13.6113 13.3724C14.941 13.3724 16.2712 13.0056 17.5643 12.2714L17.8301 12.1204V1.44803L17.0411 1.89622C14.7979 3.17019 12.4258 3.17019 10.1815 1.89622Z",
    fill: "#FCCA26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2301_4969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17.8831,
    fill: "white",
    transform: "translate(0.919922 0.779297)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowFlag);
export default __webpack_public_path__ + "static/media/Yellow_Flag.d1d9fa41e701c5e1b887f73df29bfa9e.svg";
export { ForwardRef as ReactComponent };